import React from 'react'
import {connect} from 'react-redux'
import 'moment/locale/pt-br'
import '../../../css/components/react-datepicker.css';
import Autorizacao from '../../../security/Autorizacao';
import {
  getAdminEmpresa,
  getFinanceiroAgencia, getFinanceiroCaixa,
  getGestorEmpresa,
  getOperadorEmpresa,
  getPerfisVendedores,
  PERFIL_ADMIN,
} from '../../../security/securityContext';
import AcoesFechamentoCaixa from '../AcoesFechamentoCaixa';
import alterarExibicaoDetalhamentoFechamentoCaixa
  from '../../../actions/fechamento-caixa/usuario/alterarExibicaoDetalhamentoFechamentoCaixa';


export class FechamentoCaixa extends React.Component {

  render () {
    return (
      <div>
        <div className="resumo" style={{ backgroundColor: this.props.isFechamentoDia ? '#fff3cd' : '' }}>
          <div className="row">
            <div className="col-lg-2 col-xl-2">
              <span className="titulo-mobile">Data:&nbsp;</span>
              {this.props.fechamento.dataFechamento}
            </div>
            <div className="col-lg-3 col-xl-3">
              <span className="titulo-mobile">Agente:&nbsp;</span>
              {this.props.fechamento.nomeUsuario}
            </div>
            <div className="col-lg-2 col-xl-2">
              <span className="titulo-mobile">Quantidade de vendas:&nbsp;</span>{this.props.fechamento.quantidadeVendas}
            </div>
            <div className="col-lg-2 col-xl-2">
              <span className="titulo-mobile">Valor total de vendas R$:&nbsp;</span>
              R$: {this.props.fechamento.totais.totalVendas}
            </div>
            <div className="col-lg-2 col-xl-2">
              <span className="titulo-mobile">Situação:&nbsp;</span>
              {this.props.fechamento.descricaoSituacao}
            </div>
            <div className="col-lg-1 col-xl-1">
              <Autorizacao
                perfisPermitidos={[PERFIL_ADMIN,
                  ...getPerfisVendedores(this.props.empresaSelecionada.id),
                  getGestorEmpresa(this.props.empresaSelecionada.id),
                  getAdminEmpresa(this.props.empresaSelecionada.id),
                  getFinanceiroCaixa(this.props.empresaSelecionada.id),
                  getOperadorEmpresa(this.props.empresaSelecionada.id),
                  getFinanceiroAgencia(this.props.empresaSelecionada.id)
                ]}>
                <AcoesFechamentoCaixa item={this.props.fechamento} paginaDetalhamento='detalhe-fechamento'/>
              </Autorizacao>
            </div>
          </div>
          <div className='row m-2'>
              <div className="col">
                <strong>Valor total de comissão R$:&nbsp; {this.props.fechamento.totais.totalComissao}</strong>
              </div>
              <div className="col">
                 <strong>Valor total de depósito R$:&nbsp; {this.props.fechamento.totais.totalDeposito}</strong>
              </div>
          </div>
          {this.props.isFechamentoDia ? <div className='row ml-1'>
            <strong style={{ color: '#a17a19' }}>Fechamento do Dia</strong>
          </div> : ''}
        </div>
      </div>
    )
  }
}

export const mapStateToProps = state => (
  {
    empresaSelecionada: state.empresaSelecionada
  });

export default connect(mapStateToProps, { alterarExibicaoDetalhamentoFechamentoCaixa })(FechamentoCaixa)
